import { defineStore } from "pinia";

export const footerStore = defineStore("main", {
  state: () => ({
    background: "#edf3f9",
  }),
  actions: {
    setBackground(color) {
      this.background = color
    },
  },
});
